

import en from 'config/strings'

const validate = (values) => {
    const errors = {}

    if (values) {
        if (!values.name)
            errors.name = en.require()

        if (!values.type)
            errors.type = en.require()

        // if (!values.source_passage) {
        //     errors.source_passage = en.require()
        // }
    }

    return errors;
}

export default validate;

